<template>
  <p class="article-subheading" v-if="subheading">
    {{subheading}}
  </p>
</template>
<script>
export default {
  props: {
    subheading: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss">
  .article-subheading{
    color: white;
    font-weight: initial;
    line-height: rem-calc(28);
    font-size: rem-calc(22);
  }
</style>



// WEBPACK FOOTER //
// Subheading.vue?76e1a18a